import React from 'react'

function expiryStatus(dateStr) {
  if (!dateStr) return null
  const days = Math.ceil((new Date(dateStr) - new Date()) / 86400000)
  if (days < 0) return { label: 'Expiré', color: 'text-red-600 bg-red-50' }
  if (days <= 2) return { label: `Expire dans ${days}j`, color: 'text-orange-600 bg-orange-50' }
  if (days <= 7) return { label: `Expire dans ${days}j`, color: 'text-yellow-600 bg-yellow-50' }
  return null
}

const locationIcons = {
  fridge: '🧊',
  freezer: '❄️',
  cupboard: '🗄️',
  other: '📦',
}

export function StockItem({ item, onEdit, onDelete }) {
  const expiry = expiryStatus(item.expiry_date)

  return (
    <div className="flex items-center gap-3 py-2 border-b border-gray-100 last:border-0">
      <span className="text-lg">{locationIcons[item.location] ?? '📦'}</span>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-sm font-medium text-gray-800 truncate">{item.name}</p>
          {expiry && (
            <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${expiry.color}`}>
              {expiry.label}
            </span>
          )}
        </div>
        <p className="text-xs text-gray-500">
          {item.quantity} {item.unit}
        </p>
      </div>
      <div className="flex gap-1">
        <button onClick={() => onEdit?.(item)} className="text-gray-400 hover:text-gray-600 p-1">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        </button>
        <button onClick={() => onDelete?.(item)} className="text-gray-400 hover:text-red-500 p-1">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </div>
    </div>
  )
}
